import {
  ConfirmModalArgs,
  useConfirmModal,
} from '@/components/ConfirmationModal';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

export const useTransactionOcrConfirmModal = () => {
  const { t } = useTranslation();

  const args: ConfirmModalArgs = useMemo(
    () => ({
      title: t('received_invoice_transaction_confirm_title'),
      body: t('received_invoice_transaction_confirm_message'),
      size: 'md',
      cancelButtonProps: {
        children: t('cancel'),
        size: 'sm',
      },
      okButtonProps: {
        color: 'primary',
        children: t('received_invoice_transaction_confirm_start'),
        size: 'sm',
      },
    }),
    [t]
  );

  return useConfirmModal(args);
};
